<template>
    <div class="flex flex-col gap-6 items-center max-h-150 overflow-auto">
        <div class="size-12 hidden md:block">
            <CoachingModeMarble />
        </div>
        <h1 class="display-small-serif hidden md:inline">{{ t("chat.recap.title") }}</h1>
        <ChatInsightAccordion v-for="insight in insights" :key="`${insight.message.chat_message_id}-${insight.lineIdx}`" class="w-full" :data="insight.line" />
        <BaseAccordion v-if="profileInferences.length > 0" :accordion-ids="[accordionId]" class="accordion w-full" trigger-class="px-5" header-class="hover:bg-surface-raised">
            <template #[makeTriggerSlot(accordionId)]>
                <div class="flex items-center">
                    <PeopleAvatar v-if="userName" :name="userName" class="relative -left-2" />
                    <span class="scaffold-body-small text-left text-pretty">{{
                        t("chat.recap.memoriesSaved", { count: profileInferences.length }, profileInferences.length)
                    }}</span>
                </div>
            </template>
            <template #[makeContentSlot(accordionId)]>
                <div class="px-5 py-4 overflow-y-auto max-h-60">
                    <ChatActionProfileInferences :inferences="profileInferences" hide-forget-button />
                </div>
            </template>
        </BaseAccordion>
    </div>
</template>

<script setup lang="ts">
import ChatActionProfileInferences from "~vue/ChatActionProfileInferences.vue";
import type { ChatAction, PluckedAction } from "~vue/chatActions";
import ChatInsightAccordion from "~vue/ChatWidgets/ChatInsightAccordion.vue";
import { makeContentSlot, makeTriggerSlot } from "~vue/ChatWidgets/ChatWidgetAccordion.vue";
import BaseAccordion from "~vue/components/BaseAccordion.vue";
import CoachingModeMarble from "~vue/components/navigation/CoachingModeMarble.vue";
import PeopleAvatar from "~vue/components/PeopleAvatar.vue";
import type { UserProfileData } from "~vue/types/profile";
import { useI18n } from "vue-i18n";

type ChatRecapProps = {
    insights: PluckedAction<ChatAction.VALUES_INSIGHT | ChatAction.INTERNAL_THINKING>[];
    profileInferences: UserProfileData[];
    userName?: string;
};

defineProps<ChatRecapProps>();

const { t } = useI18n();

const accordionId = "memories";
</script>
